/*
 * Product page: „Pirkti vieną kartą“ / „Prenumeruoti“ (snippets/subscription-purchase-options.liquid).
 * - One-time (default): the theme form, Kaching tiers and buy button work as before.
 * - Subscription: Kaching tiers and the theme buy row are hidden (class pm-is-sub on the buybox).
 *   Quantity (1–3) and rhythm (Appstle plans 30/60/90 d.) start at the recommendation, which comes from
 *   custom.pakuotes_dienos: the plan whose delivery lasts closest to the rhythm (the 35 € minimum does not
 *   push the quantity up, 2026-11-04). Both recommended chips carry a „Rekomenduojame“ badge.
 * - One cart = one subscription: when the cart already holds subscription lines, the rhythm is locked to
 *   theirs so everything ships together, and those lines count towards the minimum.
 * - The minimum (35 € per delivery) is only explained here; the cart blocks checkout until it is met.
 * - The add button posts straight to /cart/add.js with selling_plan, then re-renders and opens the cart
 *   drawer (window.SeedCartDrawer, assets/seed-cart.js). The sticky bar button follows the chosen mode.
 */
(() => {
  if (window.__grasolePurchaseModes) return;
  window.__grasolePurchaseModes = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTION_ID = 'cart-drawer';
  const MAX_QTY = 3;
  let wantSub = false;
  let cartSub = { units: 0, cents: 0, days: 0 };
  let cartChecked = false;

  const i18n = (sub) => {
    if (sub.__pmI18n) return sub.__pmI18n;
    try {
      sub.__pmI18n = JSON.parse(sub.querySelector('[data-pm-i18n]').textContent);
    } catch (_) {
      sub.__pmI18n = {};
    }
    return sub.__pmI18n;
  };
  const money = (cents, locale) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(locale || 'lt-LT', { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)} €`;
    }
  };
  const fill = (template, values) => String(template || '').replace(/\{(\w+)\}/g, (_, key) => (key in values ? values[key] : ''));
  const planDays = (name) => Number(String(name || '').replace(/^\D*/, '').split(' ')[0]) || 0;

  const planChips = (sub) => [...sub.querySelectorAll('[data-pm-plan]')].sort((a, b) => Number(a.dataset.days) - Number(b.dataset.days));
  const currentPlan = (sub) => sub.querySelector('[data-pm-plan][aria-pressed="true"]') || planChips(sub)[0] || null;
  const readState = (sub) => {
    const plan = currentPlan(sub);
    return {
      t: i18n(sub),
      qty: Number(sub.dataset.qty) || 1,
      plan,
      unit: Number((plan && plan.dataset.price) || sub.dataset.unit) || 0,
      every: Number((plan && plan.dataset.days) || 0),
      packDays: Number(sub.dataset.packDays) || 0,
    };
  };
  const minOk = (sub, qty, unit) => {
    const minItems = Number(sub.dataset.minItems) || 0;
    const minCents = Number(sub.dataset.minCents) || 3500;
    return (minItems > 0 && cartSub.units + qty >= minItems) || cartSub.cents + unit * qty >= minCents;
  };
  const allowedPlans = (sub) => planChips(sub).filter((chip) => !cartSub.days || Number(chip.dataset.days) === cartSub.days);
  // Units one delivery needs so it lasts until the next one (15 % tolerance).
  const unitsFor = (packDays, every) => Math.max(1, Math.ceil(every / packDays - 0.15));
  const closeness = (packDays, qty, every) => Math.abs((packDays * qty) / every - 1);

  // Recommended {qty, chip}: the plan whose delivery lasts closest to its rhythm. A plan that meets the
  // minimum on its own wins while its oversupply stays under 35 %; ties go to the shorter rhythm.
  const recommend = (sub) => {
    const packDays = Number(sub.dataset.packDays) || 0;
    const chips = allowedPlans(sub);
    if (!packDays || !chips.length) return null;
    const options = chips.map((chip) => {
      const every = Number(chip.dataset.days);
      const qty = Math.min(MAX_QTY, unitsFor(packDays, every));
      const unit = Number(chip.dataset.price) || Number(sub.dataset.unit) || 0;
      return { chip, every, qty, score: closeness(packDays, qty, every), ok: minOk(sub, qty, unit), ratio: (packDays * qty) / every };
    });
    const pick = (list) => list.slice().sort((a, b) => a.score - b.score || a.every - b.every)[0];
    const good = options.filter((option) => option.ratio <= 1.35);
    return pick(good.length ? good : options);
  };
  // Best rhythm for a quantity the shopper picked themselves.
  const planForQty = (sub, qty) => {
    const packDays = Number(sub.dataset.packDays) || 30;
    const chips = allowedPlans(sub);
    if (!chips.length) return null;
    return chips.slice().sort((a, b) => closeness(packDays, qty, Number(a.dataset.days)) - closeness(packDays, qty, Number(b.dataset.days))
      || Number(a.dataset.days) - Number(b.dataset.days))[0];
  };
  const pressPlan = (sub, chip) => {
    if (!chip) return;
    planChips(sub).forEach((other) => other.setAttribute('aria-pressed', String(other === chip)));
  };
  const applyRecommendation = (sub) => {
    const rec = recommend(sub);
    sub.__pmRec = rec;
    if (rec && !sub.dataset.touched) {
      sub.dataset.qty = String(rec.qty);
      pressPlan(sub, rec.chip);
    }
    if (cartSub.days) {
      const current = currentPlan(sub);
      if (!current || Number(current.dataset.days) !== cartSub.days) pressPlan(sub, allowedPlans(sub)[0]);
    }
  };

  const updateSticky = (total, t) => {
    const bar = document.querySelector('[data-sticky-bar]');
    if (!bar) return;
    const label = bar.querySelector('.pdp-sticky-btn-label');
    const price = bar.querySelector('.pdp-sticky-btn-price');
    if (label && label.dataset.pmOrig === undefined) label.dataset.pmOrig = label.textContent;
    if (price && price.dataset.pmOrig === undefined) price.dataset.pmOrig = price.textContent;
    if (label) label.textContent = t.sticky || label.dataset.pmOrig;
    if (price) price.textContent = money(total, t.locale);
  };
  const restoreSticky = () => {
    document.querySelectorAll('[data-sticky-bar] [data-pm-orig]').forEach((el) => {
      el.textContent = el.dataset.pmOrig;
      delete el.dataset.pmOrig;
    });
  };

  const render = (sub) => {
    const { t, qty, unit, every, packDays } = readState(sub);
    const rec = sub.__pmRec;
    sub.querySelectorAll('[data-pm-qty]').forEach((chip) => {
      chip.setAttribute('aria-pressed', String(Number(chip.dataset.pmQty) === qty));
      chip.classList.toggle('is-rec', Boolean(rec) && Number(chip.dataset.pmQty) === rec.qty);
    });
    planChips(sub).forEach((chip) => {
      const locked = Boolean(cartSub.days) && Number(chip.dataset.days) !== cartSub.days;
      chip.classList.toggle('is-off', locked);
      chip.setAttribute('aria-disabled', String(locked));
      chip.classList.toggle('is-rec', Boolean(rec) && chip === rec.chip);
    });

    const hint = sub.querySelector('[data-pm-hint]');
    if (hint) {
      if (packDays > 0) {
        const lasts = packDays * qty;
        const short = every > 0 && lasts < every * 0.85;
        const isRec = rec && rec.qty === qty && rec.every === every;
        hint.textContent = fill(isRec ? t.rec : short ? t.hint_short : t.hint, { qty, lasts, every });
        hint.classList.toggle('is-short', short);
        hint.classList.toggle('is-rec', Boolean(isRec));
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    }
    const lock = sub.querySelector('[data-pm-lock]');
    if (lock) {
      lock.hidden = !cartSub.days;
      if (cartSub.days) lock.textContent = fill(t.lock, { every: cartSub.days });
    }
    const minNote = sub.querySelector('[data-pm-min]');
    if (minNote) minNote.hidden = minOk(sub, qty, unit);

    const total = unit * qty;
    const values = { total: money(total, t.locale), every };
    const button = sub.querySelector('[data-pm-add]');
    if (button && !button.dataset.busy) button.textContent = fill(t.button, values);
    const fine = sub.querySelector('[data-pm-fine-text]');
    if (fine) fine.textContent = fill(t.fine, values);
    if (wantSub) updateSticky(total, t);
  };

  const loadCart = async (sub) => {
    if (cartChecked) return;
    cartChecked = true;
    try {
      const response = await fetch(`${ROOT}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      const cart = await response.json();
      const lines = cart.items.filter((line) => line.selling_plan_allocation);
      cartSub = lines.reduce((sum, line) => ({
        units: sum.units + line.quantity,
        cents: sum.cents + line.final_line_price,
        days: sum.days || planDays(line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.name),
      }), { units: 0, cents: 0, days: 0 });
      if (cartSub.days && !planChips(sub).some((chip) => Number(chip.dataset.days) === cartSub.days)) cartSub.days = 0;
      applyRecommendation(sub);
      render(sub);
    } catch (_) {
      cartChecked = false;
    }
  };

  const setMode = (box, mode) => {
    const sub = box.querySelector('[data-pm-sub]');
    if (!sub) return;
    const isSub = mode === 'sub';
    wantSub = isSub;
    box.classList.toggle('pm-is-sub', isSub);
    box.querySelectorAll('[data-pm-mode]').forEach((radio) => {
      radio.checked = radio.value === mode;
      const card = radio.closest('.pm');
      if (card) card.classList.toggle('is-on', radio.checked);
    });
    const body = sub.querySelector('[data-pm-body]');
    const atc = sub.querySelector('[data-pm-atc]');
    if (body) body.hidden = !isSub;
    if (atc) atc.hidden = !isSub;
    if (isSub) {
      render(sub);
      loadCart(sub);
    } else {
      restoreSticky();
    }
  };

  const init = (box) => {
    const sub = box.querySelector('[data-pm-sub]');
    if (!sub) return;
    applyRecommendation(sub);
    // A re-rendered buybox (variant change) or a restored page keeps the shopper's choice.
    const checked = box.querySelector('[data-pm-mode]:checked');
    setMode(box, wantSub ? 'sub' : (checked && checked.value) || 'one');
  };
  const initAll = () => document.querySelectorAll('[data-product-info]').forEach(init);

  const flash = (el) => {
    if (!el) return;
    el.hidden = false;
    el.classList.remove('is-flash');
    void el.offsetWidth;
    el.classList.add('is-flash');
  };

  const addSubscription = async (sub, button) => {
    const { t, qty, plan, unit } = readState(sub);
    const error = sub.querySelector('[data-pm-error]');
    if (error) error.hidden = true;
    if (!plan) return;
    const drawer = window.SeedCartDrawer || null;
    if (drawer && !drawer.beginMutation()) return;
    button.dataset.busy = '1';
    button.disabled = true;
    button.textContent = t.adding || '…';
    let added = false;
    try {
      const payload = { items: [{ id: Number(sub.dataset.variant), quantity: qty, selling_plan: Number(plan.dataset.pmPlan) }] };
      if (drawer) {
        const url = new URL(window.location.href);
        url.searchParams.delete('sections');
        url.searchParams.delete('section_id');
        payload.sections = SECTION_ID;
        payload.sections_url = url.pathname + url.search;
      }
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      let json = {};
      try { json = await response.json(); } catch (_) {}
      if (!response.ok) {
        if (error) {
          error.textContent = json.description || json.message || t.error || '';
          error.hidden = false;
        }
        return;
      }
      added = true;
      cartSub = { units: cartSub.units + qty, cents: cartSub.cents + unit * qty, days: cartSub.days || Number(plan.dataset.days) };
      if (!drawer) {
        window.location.assign(`${ROOT}cart`);
        return;
      }
      if (!drawer.render(json.sections && json.sections[SECTION_ID])) await drawer.refreshWithRetry();
      drawer.open(button);
    } catch (err) {
      try { console.warn('[subscription-pdp]', err); } catch (_) {}
      if (drawer) await drawer.refreshWithRetry();
      if (error) {
        error.textContent = t.error || '';
        error.hidden = false;
      }
    } finally {
      if (drawer) drawer.endMutation();
      button.disabled = false;
      if (added) {
        button.textContent = t.added || '✓';
        setTimeout(() => {
          delete button.dataset.busy;
          render(sub);
        }, 1800);
      } else {
        delete button.dataset.busy;
        render(sub);
      }
    }
  };

  document.addEventListener('change', (event) => {
    const radio = event.target.closest && event.target.closest('[data-pm-mode]');
    if (!radio) return;
    const box = radio.closest('[data-product-info]');
    if (box) setMode(box, radio.value);
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest) return;
    const qtyChip = event.target.closest('[data-pm-qty]');
    if (qtyChip) {
      event.preventDefault();
      const sub = qtyChip.closest('[data-pm-sub]');
      const qty = Number(qtyChip.dataset.pmQty);
      sub.dataset.qty = String(qty);
      if (!sub.dataset.rhythmTouched) pressPlan(sub, planForQty(sub, qty));
      sub.dataset.touched = '1';
      render(sub);
      return;
    }
    const planChip = event.target.closest('[data-pm-plan]');
    if (planChip) {
      event.preventDefault();
      const sub = planChip.closest('[data-pm-sub]');
      if (planChip.getAttribute('aria-disabled') === 'true') {
        flash(sub.querySelector('[data-pm-lock]'));
        return;
      }
      sub.dataset.rhythmTouched = '1';
      sub.dataset.touched = '1';
      pressPlan(sub, planChip);
      render(sub);
      return;
    }
    const add = event.target.closest('[data-pm-add]');
    if (add) {
      event.preventDefault();
      if (!add.dataset.busy) addSubscription(add.closest('[data-pm-sub]'), add);
    }
  });

  // Sticky bar: in subscription mode its button adds the subscription instead of the one-time form.
  // Window capture runs before the theme's document-level sticky handler.
  window.addEventListener('click', (event) => {
    if (!wantSub || !event.target.closest) return;
    const sticky = event.target.closest('.pdp-sticky-btn');
    if (!sticky) return;
    const add = document.querySelector('.pm-is-sub [data-pm-add]');
    if (!add) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!add.dataset.busy) addSubscription(add.closest('[data-pm-sub]'), add);
  }, true);

  // The theme replaces the whole buybox on variant change; re-apply the choice to the new markup.
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-product-info]')) init(node);
        else if (node.matches('[data-sticky-bar]') && wantSub) {
          const sub = document.querySelector('.pm-is-sub [data-pm-sub]');
          if (sub) render(sub);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Subscription lines added or removed in the drawer change the rhythm lock and the minimum.
  document.addEventListener('cart:updated', () => {
    cartChecked = false;
    const sub = document.querySelector('.pm-is-sub [data-pm-sub]');
    if (sub) loadCart(sub);
  });

  window.addEventListener('pageshow', initAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
